/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_SchemaInputs */

const en_svtag_schema = /** @type {(inputs: Svtag_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCHEMA`)
};

const ar_svtag_schema = /** @type {(inputs: Svtag_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#مخطط`)
};

const bn_svtag_schema = /** @type {(inputs: Svtag_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCHEMA`)
};

const de_svtag_schema = /** @type {(inputs: Svtag_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCHEMA`)
};

const es_svtag_schema = /** @type {(inputs: Svtag_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCHEMA`)
};

const fr_svtag_schema = /** @type {(inputs: Svtag_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCHEMA`)
};

const pt_svtag_schema = /** @type {(inputs: Svtag_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCHEMA`)
};

const zh_svtag_schema = /** @type {(inputs: Svtag_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCHEMA`)
};

const tr_svtag_schema = /** @type {(inputs: Svtag_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCHEMA`)
};

const ru_svtag_schema = /** @type {(inputs: Svtag_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCHEMA`)
};

const pl_svtag_schema = /** @type {(inputs: Svtag_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SCHEMA`)
};

/**
* | output |
* | --- |
* | "#SCHEMA" |
*
* @param {Svtag_SchemaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_schema = /** @type {((inputs?: Svtag_SchemaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_SchemaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_schema(inputs)
	if (locale === "bn") return bn_svtag_schema(inputs)
	if (locale === "de") return de_svtag_schema(inputs)
	if (locale === "es") return es_svtag_schema(inputs)
	if (locale === "fr") return fr_svtag_schema(inputs)
	if (locale === "pt") return pt_svtag_schema(inputs)
	if (locale === "zh") return zh_svtag_schema(inputs)
	if (locale === "tr") return tr_svtag_schema(inputs)
	if (locale === "ru") return ru_svtag_schema(inputs)
	if (locale === "pl") return pl_svtag_schema(inputs)
	return en_svtag_schema(inputs)
});